import React from 'react';
import { rfc3986EncodeURIComponent } from '@sda/utils/url';
import { SomethingWentWrong } from '@client/components/Main/SomethingWentWrong';

export class Main extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      errorInfo: false,
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }

  render() {
    const { error, errorInfo } = this.state;

    if (error) {
      return (
        <div>
          <div className="error-boundary">
            <div>
              <h2>Something went wrong</h2>

              <h3>
                Please reach out to
                &nbsp;
                <a
                  href={`
                    mailto:${process.env.SUPPORT_EMAIL}
                    ?body=${rfc3986EncodeURIComponent(`\r\n\r\nType above this line --------------\r\n\r\n${error.toString()}\r\n${errorInfo.componentStack}`)}
                  `}
                >
                  support
                </a>
                &nbsp;
                for any assistance. You may wish to try another browser while waiting for us to respond.
              </h3>
            </div>
          </div>
        </div>
      );
    }

    return (
      <SomethingWentWrong />
    );
  }
}
